import React from 'react';

import { CLIVE_VIBERANT_BORDER } from '~/components/Clive/cliveRegistry';
import { Text } from '~/components/core/TextComponents';
import cn from '~/Utils/cn';

/**
 * Marks the insight as the latest version of its key and not yet dismissed.
 *
 * Only the latest insight can be new, so this deliberately has no place on a history version —
 * every version below the latest has been superseded by definition.
 */
export const LatestVersionBadge: React.FC = () => (
  <span className={cn('gap-6 flex items-center rounded-full px-16 py-4', CLIVE_VIBERANT_BORDER)}>
    <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.SEMI_BOLD} colorVariant={Text.COLOR_VARIANTS.BLACK}>
      New
    </Text>
  </span>
);
